/* eslint-disable react-hooks/exhaustive-deps */
import { useRef, useState, useEffect } from "react";
import classNames from "classnames";
import { useDebounce } from "use-debounce";
import { useOutsideClick } from "hooks";
import styled from "styled-components";
import { useQuery } from "react-query";
import { AiFillCaretDown, AiOutlineClose } from "react-icons/ai";
import ClipLoader from "react-spinners/ClipLoader";
import "./style.scss";

export const SearchManufacturer = ({
  value,
  onChange,
  label,
  className,
  backgroundColor = "#eee",
  placeholder = "Search or type here",
  width,
  idField = "alt_i",
  displayValue = "",
  func = () => { },
  onSelectId = () => { },
  onSelectValue = () => { },
  onClick = () => { },
  onFocus = () => { },
}) => {
  const menuRef = useRef(null);
  const [search, setSearch] = useState("");
  const [showResults, setShowResults] = useState(false);
  const [debouncedValue] = useDebounce(search, 500);
  const [innerValue, setInnerValue] = useState("");

  useOutsideClick(menuRef, clickOutsideMenu);
  function clickOutsideMenu() {
    setShowResults(false);
  }
  const handleChange = (params) => {
    if (params !== value) {
      setSearch("");
      onChange(params[idField]);
      onSelectId(params[idField]);
      setInnerValue(params.alt_nm);
      onSelectValue(params.alt_nm, params);
    }
    setShowResults(false);
  };

  const { data, isLoading, isFetching } = useQuery(
    [debouncedValue],
    () => {
      console.log("d", debouncedValue)
      return func(debouncedValue)},
    {
      keepPreviousData: true,
      enabled: debouncedValue.length > 0,
    }
  );

  const [focused, setFocused] = useState(false);

  const handleBlur = (event) => {
    setFocused(false);
    onFocus(false)
  };

  const handleClear = () => {
    onChange("");
    setSearch("");
    onSelectId("");
    setInnerValue("");
    onSelectValue("");
  };

  useEffect(() => {
    if (debouncedValue) {
      setShowResults(true);
    } else {
      setShowResults(false);
    }
    return () => { };
  }, [debouncedValue]);

  useEffect(() => {
    if (displayValue) {
      setInnerValue(displayValue);
    }
    return () => { };
  }, [displayValue]);

  useEffect(() => {
    if (!value) {
      setInnerValue("");
    }
    return () => { };
  }, [value]);

  console.log(data)
  return (
    <div className={className} onClick={onClick}>
      {label && <span className="searchable-drop-down-label my-auto">{label}</span>}
      <div className="auto-complete" style={{ width }}>
        <div className="menu-button" style={{ width }}>
          {innerValue ? (
            <>
              <InnerValue className="mr-auto" value={innerValue} readOnly />
              <button
                className="menu-button__drop-down"
                onClick={() => handleClear()}>
                <AiOutlineClose
                  color="white"
                  alt="clear"
                />
              </button>
            </>
          ) : (
            <div className="d-flex w-100">
              <StyledInput
                type="text"
                aria-labelledby={"auto complete"}
                onFocus={() => {
                  setFocused(true)
                  onFocus(true)
                }}
                onBlur={handleBlur}
                aria-describedby={"auto complete"}
                value={search}
                placeholder={placeholder}
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
              />

              <AiFillCaretDown
                color="white"
                className="menu-button__drop-down"
                alt="drop-down"
              />
            </div>
          )}

          <Underline focused={focused} />
        </div>
        {showResults && (
          <div ref={menuRef} className="menu-dropdown">
            {isLoading || isFetching ? (
              <div className="d-flex justify-content-center py-4">
                <ClipLoader size={32} color="#006280" />
              </div>
            ) : data.payload.manufacturer?.length > 0 ? (
              data.payload.manufacturer.map((item, index) => {
                return (
                  <div
                    className={classNames(
                      "menu-item",
                      item.alt_nm === value ? "active" : ""
                    )}
                    key={`key${index}`}
                    onClick={() => handleChange(item)}
                    style={{ width }}
                  >
                    {item.alt_nm}
                  </div>
                );
              })
            ) : (
              <div className="my-3 d-flex justify-content-center">
                No results
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

const StyledInput = styled.input`
  background: transparent;
  color: white;
  border: none;
  height: 32px;
  line-height: 32px;
  width: calc(100% - 24px);
  font-size: 14px;
  outline: none;
  &:focus,
  &:hover {
    border: none;
    outline: none;
  }
`;

const Underline = styled.div`
  background: ${(props) => props.theme.palette.primary};
  width: 100%;
  height: 2px;
  position: absolute;
  bottom: 0;
  transform-origin: left;
  transition: transform 500ms ease;
  transform: ${(props) => (props.focused ? "" : "scale3d(0, 1, 1)")};
`;

const InnerValue = styled.input`
  background: transparent;
  border: none;
  outline: none;
  color: white;
  width: 300px;
  &:focus{
    border: none;
    outline: none;
  }
`
